import { ChatRole } from '@/interfaces';

export const parserUserMessage = (message: string, role: ChatRole): string => {
	let messageToReturn = message;

	if (role === 'system' || role === 'bot') {
		messageToReturn = `
           <div className="flex flex-col">
                <span className="p-3 rounded-2xl w-fit rounded-tl-none bg-green-20">
                    <p className="text-black font-normal text-sm xl:text-sm">${message}</p>
                </span>
            </div>
       `;
	}

	if (role === 'user') {
		messageToReturn = `
           <div className="flex flex-col justify-end items-end">
                   <span className="p-3 rounded-2xl w-fit rounded-tr-none border bg-purple-35">
                       <p className="text-black font-normal text-sm xl:text-sm">${message}</p>
                   </span>
               </div>
       `;
	}

	if (role === 'lawyer') {
		messageToReturn = `
           <div className="flex flex-col">
                   <span className="p-3 rounded-2xl w-fit rounded-tl-none bg-grey-10">
                       <p className="text-black font-normal text-sm xl:text-sm">${message}</p>
                   </span>
               </div>
       `;
	}
	return messageToReturn;
};
